import { Defaults } from 'es-decorators'
import { Model } from '../components/model'
import reduce from 'lodash/reduce'
import { Collection } from '../components/collection'

/**
 * Коллекция выбранных фильтров.
 */
@Defaults({
  model: Model,
  chosenFiltersQty: 0,
})
export class ChosenFilters extends Collection {
  /**
   * @inheritDoc
   */
  run () {
    this.listenTo(this, 'reset', this.countChosenFilters)
  }

  /**
   * Считает количество выбранных фильтров с учетом вложенных фильтров
   */
  countChosenFilters () {
    this.chosenFiltersQty = reduce(this.toJSON(), (acc, cur) => {
      const qty = cur.selectedQty ? cur.selectedQty : 1
      acc += qty
      return acc
    }, 0)

    this.trigger('has-chosen-filters')
  }
}
